import { render, staticRenderFns } from "./submission-panel-supporter-interests.vue?vue&type=template&id=25c8a104&scoped=true&"
import script from "./submission-panel-supporter-interests.vue?vue&type=script&lang=ts&"
export * from "./submission-panel-supporter-interests.vue?vue&type=script&lang=ts&"
import style0 from "./submission-panel-supporter-interests.vue?vue&type=style&index=0&id=25c8a104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8a104",
  null
  
)

export default component.exports